import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = ({ onShowPolicy }) => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-links">
            <a 
              href="https://yuuu.es" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="footer-link"
            >
              Powered and Developed by Yuuu
            </a>
            <a 
              href="https://liberapay.com/TheWNetwork" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="donation-button"
            >
              <i className="fas fa-donate"></i> Donate
            </a>
            <button 
              onClick={() => onShowPolicy('cookie')} 
              className="footer-link policy-link"
            >
              {t('footer.cookiePolicy')}
            </button>
            <button 
              onClick={() => onShowPolicy('privacy')} 
              className="footer-link policy-link"
            >
              {t('footer.privacyPolicy')}
            </button>
            <button 
              onClick={() => onShowPolicy('terms')} 
              className="footer-link policy-link"
            >
              {t('footer.termsConditions')}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
